function stickyNavTabs(containerSelector, linkSelector) {
  const currentHash = window.location.hash;

  if (currentHash) {
    $(`${containerSelector} ${linkSelector}[href="${currentHash}"]`).tab('show');
  }

  $(containerSelector).on('click', linkSelector, (e) => {
    const $tab = $(e.target);
    const href = $tab.attr('href');

    if (!href) return;

    window.location.hash = href;
  });
}

export default stickyNavTabs;
